'use client';

import { useUtmAttribution } from '@hooks/analytics/useUtmAttribution';

/**
 * @description Captures UTM params (with consent) and syncs last-touch attribution.
 */
export const UtmAttributionTracker = () => {
  useUtmAttribution();
  return null;
};
